<script setup>
import { DsButton } from '@dss360/design-system'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/modules/auth/stores/auth.store'

const { t } = useI18n()
const router = useRouter()
const authStore = useAuthStore()

const currentCompanyName = computed(() => authStore.companyData?.name || '')

function openClientSelection() {
  router.push({ name: 'digital-leader-clients' })
}
</script>

<template>
  <div class="flex items-center gap-3">
    <span class="text-sm font-medium text-dss-secondary-700 truncate max-w-48">
      {{ currentCompanyName }}
    </span>
    <ds-button
      :label="t('digital-leader.header.switch-company')"
      icon="pi pi-arrow-right-arrow-left"
      severity="secondary"
      outlined
      size="small"
      @click="openClientSelection"
    />
  </div>
</template>
